const authenticationEvents = {
    Errored: {
        Name: "AUTHENTICATION.ERRORED",
        New(error) {
            return {
                type: authenticationEvents.Errored.Name,
                Error: error
            };
        }
    },
    ClearError: {
        Name: "AUTHENTICATION.CLEARERROR",
        New() {
            return {
                type: authenticationEvents.ClearError.Name
            };
        }
    }
};

module.exports = authenticationEvents;


// WEBPACK FOOTER //
// ./src/events/authentication/authenticationEvents.js